import { ColorEnum } from '@/constants/color'
import Notification from '@/features/notifications/components/Notification'
import { ProgressBar } from '@/features/ui'
import IconButton from '@/features/ui/buttons/components/IconButton'
import CloseIcon from '@/features/ui/icons/components/CloseIcon'
import { ComponentType, FC, ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'
import { SvgProps } from 'react-native-svg'

interface HeaderNotificationProps {
    Icon: ComponentType<SvgProps>
    iconContainerColor: ColorEnum
    Title: ReactNode
    Description?: ReactNode
    onPress?: () => void
    onClose: () => void
}

const HeaderNotification: FC<HeaderNotificationProps> = ({
    Icon,
    iconContainerColor,
    Title,
    Description,
    onPress,
    onClose,
}) => {
    return (
        <View style={styles.outerContainer}>
            <Notification onPress={onPress} style={styles.innerContainer}>
                <Notification.IconContainer Icon={Icon} color={iconContainerColor} size={32} />
                <View style={styles.titleAndDescriptionContainer}>
                    {Title}
                    {Description}
                </View>
                <IconButton mode="rounded" size={32} Icon={CloseIcon} onPress={onClose} />
            </Notification>
            <ProgressBar duration={10000} onProgressEnd={onClose} style={styles.progressBar} />
        </View>
    )
}

const styles = StyleSheet.create({
    outerContainer: {
        backgroundColor: ColorEnum.WHITE,
        borderRadius: 30,
        overflow: 'hidden',
        width: '100%',
        maxWidth: 360,
    },
    innerContainer: {
        paddingVertical: 6,
        paddingLeft: 8,
        paddingRight: 12,
    },
    titleAndDescriptionContainer: {
        flex: 1,
        marginLeft: 8,
        gap: 4,
    },
    progressBar: {
        backgroundColor: ColorEnum.YELLOW_500,
        position: 'absolute',
        bottom: -1,
    },
})

export default HeaderNotification
